var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50159 2C5.72691 2 5.24643 2.84285 5.64109 3.50945L8.60132 8.50945C8.78134 8.81352 9.10847 9 9.46182 9H10.2676C10.0974 9.29417 10 9.63571 10 10C10 10.113 10.0094 10.2239 10.0274 10.3318C7.68272 11.1477 6.00001 13.3773 6.00001 16C6.00001 19.3137 8.6863 22 12 22C15.3137 22 18 19.3137 18 16C18 13.3773 16.3173 11.1477 13.9726 10.3318C13.9906 10.2239 14 10.113 14 10C14 9.63571 13.9026 9.29417 13.7324 9H14.5382C14.8915 9 15.2187 8.81352 15.3987 8.50945L18.3589 3.50945C18.7536 2.84285 18.2731 2 17.4984 2H14.6423C14.2889 2 13.9618 2.18648 13.7818 2.49055L12 5.50002L10.2183 2.49055C10.0382 2.18648 9.71111 2 9.35776 2H6.50159ZM12.4996 10.0205C12.3349 10.0069 12.1682 10 12 10C11.8318 10 11.6652 10.0069 11.5004 10.0205C11.5001 10.0137 11.5 10.0069 11.5 10C11.5 9.72386 11.7239 9.5 12 9.5C12.2761 9.5 12.5 9.72386 12.5 10C12.5 10.0069 12.4999 10.0137 12.4996 10.0205Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal6);
export default __webpack_public_path__ + "static/media/medal-6.b2919ee1fa315a4d51edac204577f9a1.svg";
export { ForwardRef as ReactComponent };